import { useRef, useState } from 'react'

import { useRouter } from 'next/router'

import clsx from 'clsx'
import { useClickAway } from 'react-use'

import { getBaseUrl } from '@/lib/contentful/utils'

import { Button } from '@/components/Button'
import { MarketoForm } from '@/components/MarketoForm'

type Props = {
	formId?: string
	submitText?: string
	postTitle?: string
	displayText?: string | null
	title?: string | null
	slug?: string | null
}

export const MarketoCTA = ({
	formId,
	displayText,
	title,
	slug,
	postTitle = 'Fill out the form below to get started',
	submitText = 'Request a Demo'
}: Props) => {
	const [isOpen, setIsOpen] = useState(false)
	const { locale } = useRouter()

	const modalRef = useRef<HTMLDivElement>(null)

	useClickAway(modalRef, () => {
		setIsOpen(false)
	})

	return (
		<div className="grid grid-flow-row gap-4 px-4">
			<h5 className="text-[20px] leading-[27px] text-black-100 font-medium">{title}</h5>
			<Button
				variant="subtle"
				color="secondary"
				onClick={() => setIsOpen(true)}
				className="w-fit"
				size="large"
				showIcon={true}
			>
				{displayText}
			</Button>

			{isOpen && (
				<div className={clsx('fixed inset-0 bg-black/25 flex justify-center items-center z-50')}>
					<div
						className="w-full max-h-[90svh] mx-4 max-w-md overflow-x-hidden overflow-y-auto rounded-2xl bg-white p-6 text-left align-middle shadow-xl relative"
						ref={modalRef}
					>
						<button
							className="absolute text-lg top-2 right-6 cursor-pointer flex h-6 w-6 justify-center"
							onClick={() => setIsOpen(false)}
						>
							<span className="sr-only">close modal</span>X
						</button>
						<MarketoForm
							formId={formId}
							submitText={submitText}
							postTitle={postTitle}
							style="default"
							size="default"
							align="left"
							color="primary"
							className="pt-6"
							isModal
							postUrl={`${getBaseUrl(locale)}/blog/${slug}`}
							onSuccessCallback={() => setIsOpen(false)}
						/>
					</div>
				</div>
			)}
		</div>
	)
}
